module.exports = __webpack_public_path__ + "static/instant_loan_approval-8cc42ebee120c94d3c7575f04ae4aa25.webp";